export const breakpoints = {
  small: 0,
  medium: 640,
  large: 768,
  xlarge: 1024,
  xxlarge: 2048,
};
